<template>
  <div class="flex flex-col gap-4">
    <div>
      <base-label id="daktelaUrl" label="Daktela URL"/>
      <base-input id="daktelaUrl"
                  name="daktelaUrl"
                  variant="editor"
                  type="text"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.daktela_url ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.daktela_url"
                  placeholder="https://company.daktela.com"
                  @input="$emit('update:daktelaUrl', $event)"
                  @blur="emitNormalizedUrl"
      />
      <span v-if="fieldErrors.daktela_url" class="text-xs text-focus-error mt-1">{{ fieldErrors.daktela_url }}</span>
    </div>

    <div>
      <base-label id="accessToken"
                  label="Access Token"
                  :tooltip="isEditMode ? '' : 'Find your access token in Manage - Routings - Web chats - select a Connector - Get Code button'"
      />
      <base-input id="accessToken"
                  name="accessToken"
                  variant="editor"
                  type="text"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.access_token ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.access_token"
                  @input="$emit('update:accessToken', $event)"
      />
      <span v-if="fieldErrors.access_token" class="text-xs text-focus-error mt-1">{{ fieldErrors.access_token }}</span>
    </div>

    <div v-if="isEditMode && showUnreleased">
      <base-label id="refreshChatPeriodMs" label="Refresh Chat Period (ms)" :is-admin="true"/>
      <base-input id="refreshChatPeriodMs"
                  name="refreshChatPeriodMs"
                  variant="editor"
                  type="number"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.refresh_chat_period_ms ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.refresh_chat_period_ms"
                  @input="$emit('update:refreshChatPeriodMs', $event)"
      />
      <span v-if="fieldErrors.refresh_chat_period_ms" class="text-xs text-focus-error mt-1">{{ fieldErrors.refresh_chat_period_ms }}</span>
    </div>

    <div v-if="isEditMode && showUnreleased">
      <base-label id="refreshChatRepeatCount" label="Refresh Chat Repeat Count" :is-admin="true"/>
      <base-input id="refreshChatRepeatCount"
                  name="refreshChatRepeatCount"
                  variant="editor"
                  type="number"
                  :class="['w-full py-px mt-1 h-10', fieldErrors.refresh_chat_repeat_count ? 'border-focus-error focus:border-focus-error' : 'border-gray']"
                  :value="formData.refresh_chat_repeat_count"
                  @input="$emit('update:refreshChatRepeatCount', $event)"
      />
      <span v-if="fieldErrors.refresh_chat_repeat_count" class="text-xs text-focus-error mt-1">{{ fieldErrors.refresh_chat_repeat_count }}</span>
    </div>

    <div v-if="isEditMode && showUnreleased">
      <base-label id="refreshChatType" label="Refresh Chat Type" :is-admin="true"/>
      <base-select id="refreshChatType"
                   :value="formData.refresh_chat_type"
                   :options="refreshChatTypeOptions"
                   class="w-full border-gray mt-1 h-10"
                   @input="$emit('update:refreshChatType', $event)"
      />
      <span v-if="fieldErrors.refresh_chat_type" class="text-xs text-focus-error mt-1">{{ fieldErrors.refresh_chat_type }}</span>
    </div>

    <div>
      <base-label id="bots"
                  label="Bots"
      />
      <queryable-select id="bots"
                        :value="selectedBotId"
                        :options="botOptions"
                        :class="['w-full mt-1 h-10', fieldErrors.bots ? 'border-focus-error' : 'border-gray']"
                        :is-disabled="loaders.bots"
                        @input="$emit('update:botId', $event)"
      />
      <span v-if="fieldErrors.bots" class="text-xs text-focus-error mt-1">{{ fieldErrors.bots }}</span>
      <span v-else-if="loaders.bots" class="text-xs text-gray-dark mt-1">Loading bots...</span>
      <span v-else-if="botOptions.length === 0 && !isEditMode" class="text-xs text-gray-dark mt-1">No bots available. Please create a bot first.</span>
    </div>
  </div>
</template>

<script>
import BaseSelect from '@/components/base-components/BaseSelect.vue'
import QueryableSelect from '@/components/common/QueryableSelect.vue'
import mixins from '@/utils/mixins'
import { REFRESH_CHAT_TYPES } from '@/utils/integration.constants'
import { normalizeDaktelaUrl } from '@/utils/integration.utils'

export default {
  name: 'DaktelaChatIntegrationForm',

  components: { BaseSelect, QueryableSelect },
  mixins: [mixins],

  props: {
    formData: {
      type: Object,
      required: true,
      validator: (value) => {
        return 'daktela_url' in value &&
               'access_token' in value &&
               'refresh_chat_period_ms' in value &&
               'refresh_chat_repeat_count' in value &&
               'refresh_chat_type' in value
      }
    },
    selectedBotId: {
      type: String,
      default: ''
    },
    fieldErrors: {
      type: Object,
      default: () => ({})
    },
    botOptions: {
      type: Array,
      required: true
    },
    loaders: {
      type: Object,
      default: () => ({ bots: false })
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'update:daktelaUrl',
    'update:accessToken',
    'update:refreshChatPeriodMs',
    'update:refreshChatRepeatCount',
    'update:refreshChatType',
    'update:botId'
  ],

  computed: {
    refreshChatTypeOptions() {
      return [
        { text: 'Short', value: REFRESH_CHAT_TYPES.SHORT },
        { text: 'Long', value: REFRESH_CHAT_TYPES.LONG }
      ]
    }
  },

  methods: {
    emitNormalizedUrl() {
      this.$emit('update:daktelaUrl', normalizeDaktelaUrl(this.formData.daktela_url))
    }
  }
}
</script>
